export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10798.b71d4d79.jpg";